import React, { useEffect } from 'react'
import { View } from 'react-native'
import { useSelector, useDispatch } from 'react-redux'
import v4 from 'uuid/v4'

import { watchWorkstreamTasks } from '../../../utils/backends/Tasks/myDayTasks'
import { unwatch } from '../../../utils/backends/firestore'
import { clearMyDayAllTodayTasksInWorkstream, clearOpenTasksShowMoreDataInWorkstream } from '../../../redux/actions'

export default function MyDayTasksWorkstreamLoaders({ projectId, workstreamId }) {
    const dispatch = useDispatch()
    const loggedUserId = useSelector(state => state.loggedUser.uid)

    useEffect(() => {
        const watcherKey = v4()
        watchWorkstreamTasks(projectId, loggedUserId, workstreamId, watcherKey)
        return () => {
            unwatch(watcherKey)
        }
    }, [projectId, loggedUserId, workstreamId])

    useEffect(() => {
        return () => {
            dispatch(clearMyDayAllTodayTasksInWorkstream(projectId, workstreamId))
        }
    }, [])

    // Later/Someday availability for the board is computed by NeedShowMoreOpenTasksButton; see
    // MyDayTasksProjectLoaders. Only the clean-up of this workstream's flags stays here.
    useEffect(() => {
        return () => {
            dispatch(clearOpenTasksShowMoreDataInWorkstream(projectId, workstreamId))
        }
    }, [])

    return <View></View>
}
